/* eslint-disable */
/**
 * SvIkon — central ikon-komponent der mapper navn → Lucide-React ikon
 * Bruges overalt i appen som erstatning for emoji-ikoner
 */
import React from 'react';
import {
  Home, Settings, Search, BarChart2, TrendingUp, TrendingDown,
  ClipboardList, FileEdit, FileText, FolderOpen, Folder,
  Calendar, CalendarDays, FolderKanban, CheckCircle2, Check, X,
  XCircle, Pencil, PenLine, Trash2, Save, RefreshCw, Repeat,
  Plus, Download, Upload, Inbox, Send, Mail, Mailbox, MailOpen,
  AlertTriangle, AlertCircle, Ban, Lightbulb, Bell, BellOff, Flag,
  User, Users, Handshake, Baby, Hourglass, AlarmClock, Timer,
  Clock, PauseCircle, Lock, Unlock, KeyRound, Key, Shield,
  Printer, Paperclip, Image, Video, Music, Phone, Smartphone,
  Monitor, Laptop, Building2, Landmark, CreditCard, DollarSign,
  Banknote, Scale, Bot, Brain, Rocket, Target, Globe, Link,
  Microscope, Pin, Puzzle, Sprout, MessageCircle, Map, Eye, EyeOff,
  Camera, BookOpen, Megaphone, PartyPopper, Sparkles, Smile, Bug,
  Menu, Cloud, Sun, Moon, Leaf, Construction, Music2, Calculator,
  Palette, Volume2, Package, Briefcase, Heart, Compass, Power, Tv,
  ArrowUp, IdCard, Hash, Network, PlayCircle, Pause, ChevronDown,
  ChevronUp, ChevronRight, ChevronLeft, Info, HelpCircle, MoreHorizontal,
  Star, Zap, Activity, Layout, Grid, List, Table, Filter, SlidersHorizontal,
  ExternalLink, Copy, FileCheck, FilePlus, FileX, FileSearch,
  Layers, Tag, Tags, Bookmark, Share2, Archive, ArchiveX,
  MessageSquare, MessageCircleMore, Phone as PhoneCall, UserPlus,
  UserCheck, UserX, Building, MapPin, Navigation, Heading,
  LogIn, LogOut, CircleDot, ToggleLeft, ToggleRight, RadioTower,
} from 'lucide-react';

// Mapping fra emoji-string og ikon-navn → Lucide komponent
const IKON_MAP = {
  // Navigation
  'Home': Home, 'hjem': Home,
  'Settings': Settings, 'indstillinger': Settings,
  'Search': Search, 'soeg': Search,
  'BarChart2': BarChart2, 'statistik': BarChart2,
  'TrendingUp': TrendingUp, 'op': TrendingUp,
  'TrendingDown': TrendingDown, 'ned': TrendingDown,
  'ClipboardList': ClipboardList, 'clipboard': ClipboardList,
  'FileEdit': FileEdit, 'note': FileEdit,
  'FileText': FileText, 'dokument': FileText,
  'FolderOpen': FolderOpen, 'mappe-aaben': FolderOpen,
  'Folder': Folder, 'mappe': Folder,
  'Calendar': Calendar, 'kalender': Calendar,
  'CalendarDays': CalendarDays,
  'FolderKanban': FolderKanban,
  // Status
  'CheckCircle2': CheckCircle2, 'check-circle': CheckCircle2,
  'Check': Check, 'check': Check,
  'X': X, 'luk': X,
  'XCircle': XCircle,
  'Pencil': Pencil, 'rediger': Pencil,
  'PenLine': PenLine,
  'Trash2': Trash2, 'slet': Trash2,
  'Save': Save, 'gem': Save,
  'RefreshCw': RefreshCw, 'opdater': RefreshCw,
  'Repeat': Repeat,
  'Plus': Plus,
  'Download': Download,
  'Upload': Upload,
  'Inbox': Inbox,
  'Send': Send,
  'Mail': Mail, 'mail': Mail,
  'Mailbox': Mailbox,
  'MailOpen': MailOpen,
  // Alerts
  'AlertTriangle': AlertTriangle, 'advarsel': AlertTriangle,
  'AlertCircle': AlertCircle, 'fejl': AlertCircle,
  'Ban': Ban,
  'Lightbulb': Lightbulb, 'ide': Lightbulb,
  'Bell': Bell,
  'BellOff': BellOff,
  'Flag': Flag,
  // People
  'User': User, 'bruger': User,
  'Users': Users, 'brugere': Users,
  'Handshake': Handshake, 'moede': Handshake,
  'Baby': Baby,
  // Time
  'Hourglass': Hourglass, 'venter': Hourglass,
  'AlarmClock': AlarmClock,
  'Timer': Timer,
  'Clock': Clock, 'tid': Clock,
  'PauseCircle': PauseCircle,
  // Security
  'Lock': Lock,
  'Unlock': Unlock,
  'KeyRound': KeyRound,
  'Key': Key, 'noegle': Key,
  'Shield': Shield,
  // Media/Files
  'Printer': Printer,
  'Paperclip': Paperclip,
  'Image': Image, 'billede': Image,
  'Video': Video, 'video': Video,
  'Music': Music, 'lyd': Music,
  'Phone': Phone, 'telefon': Phone,
  'Smartphone': Smartphone,
  'Monitor': Monitor,
  'Laptop': Laptop,
  // Business
  'Building2': Building2, 'virksomhed': Building2,
  'Landmark': Landmark, 'institution': Landmark,
  'CreditCard': CreditCard,
  'DollarSign': DollarSign, 'penge': DollarSign,
  'Banknote': Banknote,
  'Scale': Scale, 'jura': Scale,
  // Tech
  'Bot': Bot, 'ai': Bot,
  'Brain': Brain, 'hjerne': Brain,
  'Rocket': Rocket, 'deploy': Rocket,
  'Target': Target, 'maal': Target,
  'Globe': Globe,
  'Link': Link,
  'Microscope': Microscope,
  'Pin': Pin,
  'Puzzle': Puzzle,
  'Sprout': Sprout,
  'MessageCircle': MessageCircle, 'besked': MessageCircle,
  'Map': Map,
  'Eye': Eye, 'vis': Eye,
  'EyeOff': EyeOff, 'skjul': EyeOff,
  'Camera': Camera,
  'BookOpen': BookOpen,
  'Megaphone': Megaphone,
  'PartyPopper': PartyPopper,
  'Sparkles': Sparkles,
  'Smile': Smile,
  'Bug': Bug,
  'Menu': Menu,
  'Cloud': Cloud,
  'Sun': Sun,
  'Moon': Moon,
  'Leaf': Leaf,
  'Construction': Construction,
  'Music2': Music2,
  'Calculator': Calculator,
  'Palette': Palette,
  'Volume2': Volume2,
  'Package': Package,
  'Briefcase': Briefcase,
  'Heart': Heart,
  'Compass': Compass,
  'Power': Power,
  'Tv': Tv,
  'ArrowUp': ArrowUp,
  'IdCard': IdCard,
  'Hash': Hash,
  'Network': Network,
  'Activity': Activity,
  'Star': Star,
  'Zap': Zap,
  'Info': Info,
  'HelpCircle': HelpCircle,
  'ExternalLink': ExternalLink,
  'Archive': Archive,
  'Tag': Tag,
  'LogOut': LogOut,
  'LogIn': LogIn,
  'RadioTower': RadioTower,
};

/**
 * Rendrer et ikon baseret på navn
 * @param {string} navn - Ikon-navn (Lucide komponent-navn)
 * @param {number} size - Størrelse i px (default: 16)
 * @param {string} color - Farve (default: current color)
 * @param {object} style - Ekstra styles
 * @param {string} className - CSS klasse
 */
export function SvIkon({ navn, size = 16, color, style, className, strokeWidth = 1.5 }) {
  const IkonKomponent = IKON_MAP[navn];
  if (!IkonKomponent) {
    // Fallback: vis et cirkel-ikon hvis navn ikke kendes
    return <span style={{ display: 'inline-block', width: size, height: size, ...style }} />;
  }
  return (
    <IkonKomponent
      size={size}
      color={color}
      style={{ flexShrink: 0, ...style }}
      className={className}
      strokeWidth={strokeWidth}
    />
  );
}

export default SvIkon;
